import { NgModule } from '@angular/core';
import { SpinnerComponent } from './spinner.component';

@NgModule({
  declarations: [],
  imports: [SpinnerComponent],
  exports: [SpinnerComponent],
})
export class SpinnerModule {}
